export const whyChange = (value, questionId) => ({
  type: 'WHY_CHANGE',
  questionId,
  value,
});

export const matrixWhyChange = (value, rowIndex, questionId) => ({
  type: 'MATRIX_WHY_CHANGE',
  questionId,
  rowIndex,
  value,
});

export const createSubmit = () => ({
  type: 'SUBMIT',
});
